import React from 'react';
import cx from 'classnames';
import styles from './styles.module.scss';

export type RadioProps = {
    onChange: () => void;
    onFocus?: () => void;
    onBlur?: () => void;
    autoFocus?: boolean;
    componentClasses?: string;
    disabled?: boolean;
    dataTestId?: string;
    checked: boolean;
};

export const Radio = ({
    disabled,
    checked,
    onChange,
    onBlur,
    onFocus,
    autoFocus,
    dataTestId,
    componentClasses
}: RadioProps) => {
    return (
        <div className={cx(styles.container, componentClasses)}>
            <input
                data-test-id={dataTestId}
                className={styles.radio}
                disabled={disabled}
                checked={checked}
                onChange={onChange}
                type="checkbox"
                onBlur={onBlur}
                onFocus={onFocus}
                autoFocus={autoFocus}
                name="radio"
            />
        </div>
    );
};
